import React from "react";
import './AgeSelect.scss'

interface IAgeSelect {
	onChangeValue: (change: number) => void
	value: number | null
	disableSubtract: boolean
	disableAdd: boolean
	error: boolean
}

const AgeSelect: React.FC<IAgeSelect> = ({ onChangeValue, value, disableSubtract, disableAdd, error }) => {
	const onClickSubtract = (e?: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
		if (!disableSubtract) {
			onChangeValue(-1);
		}
	}

	const onClickAdd = (e?: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
		if (!disableAdd) {
			onChangeValue(1);
		}
	}

	return (
		<span className={`age-select ${error ? "error" : ""}`}>
			<div onClick={onClickSubtract} className={`left ${disableSubtract ? "disabled" : ""} ${error ? "error" : ""}`}>
				<svg width="25" height="25" className={`${disableSubtract ? "disabled" : ""}`} viewBox="0 0 35 6" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M0.46289 2.99865C0.46289 4.35249 2.01366 5.46019 3.90904 5.46019L31.4783 5.46019C33.3737 5.46019 34.9244 4.3525 34.9244 2.99865C34.9244 1.64481 33.3737 0.537116 31.4783 0.537116L3.90904 0.53711C2.01366 0.53711 0.46289 1.6448 0.46289 2.99865Z" fill={error ? "#d75f5f" : "#262626"} />
				</svg>
			</div>

			<span className={`text-3xl ${error ? "error" : ""}`}>
				{value === null ? "" : value}
			</span>

			<div onClick={onClickAdd} className={`right ${disableAdd ? "disabled" : ""} ${error ? "error" : ""}`}>
				<svg width="25" height="25" className={`${disableAdd ? "disabled" : ""}`} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M32.6953 20.4618L20.3876 20.4618L20.3876 32.7695C20.3876 34.1234 19.2799 35.2311 17.9261 35.2311C16.5722 35.2311 15.4645 34.1234 15.4645 32.7695L15.4645 20.4618L3.15685 20.4618C1.803 20.4618 0.69531 19.3541 0.69531 18.0003C0.69531 16.6465 1.803 15.5388 3.15685 15.5388L15.4645 15.5388L15.4645 3.23107C15.4645 1.87723 16.5722 0.769534 17.9261 0.769535C19.2799 0.769535 20.3876 1.87723 20.3876 3.23107L20.3876 15.5388L32.6953 15.5388C34.0492 15.5388 35.1568 16.6465 35.1568 18.0003C35.1568 19.3542 34.0492 20.4618 32.6953 20.4618Z" fill={error ? "#d75f5f" : "#262626"} />
				</svg>
			</div>
		</span>
	)
}

export default AgeSelect;
